import { w as o } from "./well-known-symbol.js";
import { o as r } from "./object-create.js";
import "./object-define-property.js";
import { __exports as e } from "../../../_virtual/object-define-property.js";
var t = e.f,
  a = o("unscopables"),
  p = Array.prototype;
void 0 == p[a] && t(p, a, {
  configurable: !0,
  value: r(null)
});
var s = function s(o) {
  p[a][o] = !0;
};
export { s as a };